import { useQuery } from 'react-query';
import { useOkapiKy, useNamespace, } from '@folio/stripes/core';
import { ORDER_TEMPLATES_API } from '../../constants';
var DEFAULT_DATA = [];
export var useOrderTemplates = function () {
    var _a, _b;
    var ky = useOkapiKy();
    var namespace = useNamespace({ key: 'order-templates' });
    var _c = useQuery({
        queryKey: [namespace],
        queryFn: function (_a) {
            var signal = _a.signal;
            return ky.get(ORDER_TEMPLATES_API, { signal: signal }).json();
        },
    }), data = _c.data, isFetching = _c.isFetching, isLoading = _c.isLoading;
    return ({
        isFetching: isFetching,
        isLoading: isLoading,
        orderTemplates: (_a = data === null || data === void 0 ? void 0 : data.orderTemplates) !== null && _a !== void 0 ? _a : DEFAULT_DATA,
        totalRecords: (_b = data === null || data === void 0 ? void 0 : data.totalRecords) !== null && _b !== void 0 ? _b : 0,
    });
};
